import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";

export interface BorrowerForTheCompanyModel {
    id: string;
    full_name: string;
    company_id: string;
    company_name: string | null;
    email: string | null;
    avatar: string | null;
    job_title: string | null;
}

const fetchBorrowersForTheCompany = async (
    companyId: string | null | undefined,
    entityId?: string | null
): Promise<BorrowerForTheCompanyModel[]> => {
    if (!companyId) {
        return [];
    }

    const { data } = await api.get<BorrowerForTheCompanyModel[]>(
        `/companies/${companyId}/borrowers`,
        {
            params: {
                entityId,
            },
        }
    );

    return data;
};

export function useBorrowersForCompany(
    companyId: string | null | undefined,
    entityId?: string | null
) {
    return useQuery({
        queryKey: ["borrowers", companyId, entityId],
        queryFn: () => fetchBorrowersForTheCompany(companyId, entityId),
        enabled: !!companyId,
    });
}
